import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { extendObservable, action } from 'mobx';
import {
  Button,
  Modal,
} from 'react-bootstrap';
import { generate } from 'shortid';
// components
import PasswordField from '../FieldGroup/PasswordField';
// stores
import UserStore from '../../stores/UserStore';

const ChangePasswordDialog = observer(
class ChangePasswordDialog extends Component {
  constructor(props) {
    super(props);

    this.ids = {
      name: generate(),
      phone: generate(),
    }

    extendObservable(this, {
      passwords: {
        current: "",
        new: "",
        confirmNew: "",
      }
    });
  }

  render() {
    const {
      show = false,
    } = this.props;

    return (
      <Modal show={show} onHide={this.onCancel} focus>
        <Modal.Header closeButton>
          <Modal.Title>Change password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={this.onSave}>
            <PasswordField
              focus
              name="current"
              hideHints={true}
              label="Current password"
              value={this.passwords.current}
              onChange={this.onChange} />
            <PasswordField
              name="new"
              hideHints={false}
              label="New password"
              value={this.passwords.new}
              onChange={this.onChange} />
            <PasswordField
              name="confirmNew"
              hideHints={true}
              label="Confirm new password"
              value={this.passwords.confirmNew}
              onChange={this.onChange} />
            <div style={{display: "none"}}>
              <Button type="submit" hidden></Button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer className="ChangePasswordDialog-footer">
          <Button onClick={this.onCancel}>Cancel</Button>
          <Button onClick={this.onSave} bsStyle="primary">Save</Button>
        </Modal.Footer>
      </Modal>
    );
  }

  onChange = action((e) => {
    const { name, value } = e.target;
    this.passwords[name] = value;
    console.log(this.passwords);
  });

  onSave = (e) => {
    e && e.preventDefault && e.preventDefault();

    const { onSave } = this.props;
    const {
      current: currentPassword,
      new: newPassword,
      confirmNew: newPassword2,
    } = this.passwords;

    if (currentPassword) {
      // reauth to make sure
      return UserStore.reauthenticate(currentPassword)
      .then(() => {
        if (newPassword === newPassword2) {
          return UserStore.changePassword(newPassword)
          .then(() => {
            onSave && onSave();
            this.clearPasswords();
          });
        }
      });
    }

    return false;
  }

  onCancel = (e) => {
    e && e.preventDefault && e.preventDefault();

    this.clearPasswords();

    let { onCancel } = this.props;
    onCancel && onCancel();

    return false;
  }

  clearPasswords = action(() => {
    this.passwords = {
      current: "",
      new: "",
      confirmNew: "",
    };
  });
});

export default ChangePasswordDialog;


// WEBPACK FOOTER //
// ./src/components/Auth/ChangePasswordDialog.js